import settings from "../utils/settings";
import SFError from "../models/SfError";
/**
 * This code use for update image on Product list page
 * @returns
 */
const useUpdateProductImage = () => {
  const updateProductImage = async ({ productId, version, image }) => {
    const { token } = settings();
    try {
      const formData = new FormData();
      formData.append("locale", "en-US");
      formData.append("__v", version);
      formData.append("image", image);
      formData.append("action", "upload_image");
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/products/${productId}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: formData,
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return [null, error.json()];
      }
      const jsonResult = await result.json();
      return [jsonResult, null];
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return [null, sfError.json()];
    }
  };
  return { updateProductImage };
};

export default useUpdateProductImage;
